import React, { useState } from "react";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import { useNotify } from "react-admin";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { fetchWithFBToken } from "../Common/swrMiddlewares";
import useSWR from "swr";
import { useProfileLocale } from "../Common/locale";

const ChartWithFilter = (props) => {
  const { token = "", chartId = "", title = "" } = props;
  const locale = useProfileLocale();
  const chartEl = React.useRef(null);
  const chartObj = React.useRef(null);
  const notify = useNotify();
  const [selectedPost, setSelectedPost] = useState({});
  const selectedPostId =
    (selectedPost && selectedPost.id && selectedPost.id.split("_").pop()) || "";

  const { data: postData, error: postError } = useSWR(
    `${process.env.REACT_APP_GRAPH_API_URL}/me/posts?limit=50&fields=id,created_time,is_hidden,is_published,message`,
    { use: [fetchWithFBToken] }
  );

  const getUserToken = React.useCallback(() => token, [token]);

  React.useEffect(() => {
    if (chartObj && chartObj.current && selectedPostId !== "") {
      const filter = {
        commentId: { $regex: `^${selectedPostId}_` },
      };
      chartObj.current.setFilter(filter);
    }
  }, [selectedPostId]);

  React.useEffect(() => {
    if (selectedPostId !== "" && chartObj !== null) {
      const sdk = new ChartsEmbedSDK({
        baseUrl: process.env.REACT_APP_CHARTS_BASE_URL,
        getUserToken: getUserToken,
        showAttribution: false,
      });
      const chart = sdk.createChart({
        chartId,
        filter: {
          commentId: { $regex: `^${selectedPostId}_` },
        },
      });
      chart
        .render(chartEl.current)
        .then((e) => {
          chartObj.current = chart;
        })
        .catch(() =>
          notify(`Chart ${chartId} initialize failed.`, { type: "warning" })
        );
    }
  }, [selectedPostId]);

  return (
    <div>
      <Card>
        <Container>
          <Box sx={{ mx: 1 }}>
            <h2>{title}</h2>
            {postData && postData.data && postData.data.length > 0 && (
              <TextField
                select
                label="Select post to view the sales"
                fullWidth
                multiline
                value={selectedPost?.id ?? ""}
                onChange={(e) => {
                  const post = postData.data.find(
                    (p) => p.id === e.target.value
                  );
                  setSelectedPost(post);
                }}
              >
                {postData.data.map(
                  ({ id, message = "no message", created_time }) => (
                    <MenuItem key={id} value={id}>
                      {` ${message} ${new Date(created_time).toLocaleString(
                        locale
                      )}`}
                    </MenuItem>
                  )
                )}
              </TextField>
            )}
          </Box>
          <div style={{ height: "500px" }}>
            <div style={{ width: "100%", height: "100%" }} ref={chartEl}></div>
          </div>
        </Container>
      </Card>
    </div>
  );
};

export default ChartWithFilter;
